export const messages = {
    nb: {
      welcome2: `Velkommen {name}!`,
      youAreNotLoggedIn: `Du har ikkje logga deg på.`,
      signedIn: 'Du er pålogget.',
      credits: `App laget av Umoe Consulting`,
      assiociation: `Forening`,
      role: `Rolle`
    }
  }  